// src/features/schoolSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import post from '../utils/post';
// import useAxios from '../hooks/useAxios';

export const fetchSchools = createAsyncThunk('schools/fetchSchools', async () => {
  const response = await post(
    process.env.REACT_APP_ADMIN_API_URL,
    {
      purpose: 'get_school_district'
    },
    () => {
        
    },
    {},
    {},
    {},
    false
  );

  return response.data.data;
});

const schoolSlice = createSlice({
  name: 'schools',
  initialState: {
    data: [],
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSchools.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchSchools.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload; // Store the fetched school data
        
      })
      .addCase(fetchSchools.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default schoolSlice.reducer;